import TemporaryUploadFile from '../dtos/TemporaryFiles'
import { HttpService } from './http'

const http = new HttpService()

export const getFileUrlPresigned = async (
  fileId: string,
  bucketName?: string
) => {
  const response = await http.post<
    { fileKey: string; bucketName?: string },
    string
  >(`policies/presigned`, {
    fileKey: fileId,
    bucketName: bucketName,
  })
  return response.data
}

export const uploadTemporaryFiles = async (files: any) => {
  try {
    const formData = new FormData()
    formData.append(
      'temporal',
      JSON.stringify({
        message: 'Upload temporary files',
      })
    )

    files.forEach((file: any) => {
      formData.append('files', file)
    })

    const response = await http.post<FormData, TemporaryUploadFile[]>(
      `files/upload-temporary-files/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error uploading temporary file:', error)
    throw new Error('Failed to upload temporary file')
  }
}

export const getBulkTemplateByCode = async (templateCode: string) => {
  try {
    const response = await http.get<Blob>(
      `files/bulk-template/${templateCode}`,
      {
        responseType: 'blob',
      }
    )
    //download file
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${templateCode}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.parentNode?.removeChild(link)
    return
  } catch (error) {
    console.error('Error fetching bulk template:', error)
    throw new Error('Failed to fetch bulk template')
  }
}

export const uploadBulkSupervisors = async (file: File, webhookUrl: string) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await http.post<FormData, Blob>(
      'user/bulk-supervisors',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-webhook-url': webhookUrl,
        },
        responseType: 'blob', // Expect a blob response for both success and error
      }
    )

    // If the response is JSON, it's a success message
    if (response.data.type === 'application/json') {
      const message = JSON.parse(await response.data.text())
      return message
    }

    // This part should not be reached on success, but as a fallback
    return { message: 'File processed.' }
  } catch (error: any) {
    throw error
  }
}
